import { RouteNames } from 'constants/routeNames'
import BenefitsCenter from './pages/BenefitsCenter'
import { userTypes } from 'modules/user'

const routes = {
  routes: [
    {
      key: 'MYATD_BENEFITS_CENTER',
      type: 'private',
      allowedUserTypes: [userTypes.MEMBER],
      title: 'MyATD - Benefits Center',
      path: `/${RouteNames.MYATD}/${RouteNames.BENEFITS_CENTER}`,
      component: BenefitsCenter,
      exact: true,
    },
  ],
}

export default routes
